import Otp from './components/Otp';
import Pin from './components/Pin';
import type { accessCredentialsModeType, IAccessCredentialComponentProps } from './DialogAccessCredentials.helpers';

interface IDialogAccessCredentialsProps extends IAccessCredentialComponentProps {
	mode: accessCredentialsModeType;
}

const DialogAccessCredentials = ({
	mode,
	type,
	title,
	description,
	dispatchAccessCredentials,
	inputLength,
	generateOTP,
	refetchFn,
	resendOtp,
	buttonTitle,
	otpCta,
	error,
	clearError,
}: IDialogAccessCredentialsProps) => {
	const AccessCredentialComponent = mode === 'otp' ? Otp : Pin;

	return (
		<AccessCredentialComponent
			type={type}
			description={description}
			dispatchAccessCredentials={dispatchAccessCredentials}
			title={title}
			inputLength={inputLength}
			generateOTP={generateOTP}
			refetchFn={refetchFn}
			resendOtp={resendOtp}
			buttonTitle={buttonTitle}
			otpCta={otpCta}
			error={error}
			clearError={clearError}
		/>
	);
};

export default DialogAccessCredentials;
